import client from '@/store/client'
import qs from 'query-string'
// import { parseStringPromise } from 'xml2js'
// import _ from 'lodash'
import parseData from '../util/parsedata'

const getDefaultState = () => {
  return {
    newProfanity: '',
    editProfanity: ''
  }
}

export default {
  namespaced: true,
  state: {
    ...getDefaultState(),
    status: '',
    queueList: [],
    profanityException: [],
    profanityList: [],
  },
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    RESET: ({ commit }) => {
      commit('reset')
    },
    GET_PROFANITY_QUEUE: async function({commit}){
      try {
        const APIRes = await client.post('/v1/Profanity.asmx/GetProfanityExceptionQueueInfo')
        commit('setField', { key: 'queueList', value: await parseData(APIRes.data) })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    GET_PROFANITY_EXCEPTION: async function({commit, state}){
      try {
        const APIRes = await client.post(`/v1/Profanity.asmx/${ state.status }`)
        commit('setField', { key: 'profanityException', value: await parseData(APIRes.data) })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    UPDATE_PROFANITY_STATUS: async function({dispatch}, data){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating',
          subdetail: 'Please wait...',
        })
        await client.post(`/v1/Profanity.asmx/${data.endpoint}`, qs.stringify({...data.data}))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Successfully Updated`, color: 'green', delay: 2500 })
        dispatch('GET_PROFANITY_QUEUE')
        dispatch('GET_PROFANITY_EXCEPTION')
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    GET_PROFANITY_LIST: async function({commit}){
      try {
        const APIRes = await client.post('/v1/Profanity.asmx/GetProfanityList')
        commit('setField', { key: 'profanityList', value: await parseData(APIRes.data) })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    SET_PROFANITY_EDITING: function({commit, state}, data) {
      if (state.editProfanity == ''){
        commit('setField', { key: 'editProfanity', value: data.text })
        commit('updatedProfanityList', data.value)
      } else {
        this.dispatch('ui/SET_TOAST', { message: `Only one item can be edited at a time`, color: 'error', delay: 2500 })
      }
    },
    UPDATE_PROFANITY: async function({commit, rootState}, data) {
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating',
          subdetail: 'Please wait...',
        })
        const APIData = {
          ...data,
          who: rootState.user.username
        }
        await client.post('/v1/Profanity.asmx/UpdateProfanity', qs.stringify(APIData))
        await this.dispatch('profanityManager/GET_PROFANITY_LIST')
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        commit('setField', { key: 'editProfanity', value: ''})
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },
    INSERT_PROFANITY: async function({commit, state, rootState}){
      try {
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Creating Profanity',
          subdetail: 'Please wait...',
        })
        await client.post('/v1/Profanity.asmx/InsertProfanity', qs.stringify({word: state.newProfanity, who: rootState.user.username}))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `New Profanity Created`, color: 'green', delay: 2500 })
        commit('setField', { key: 'newProfanity', value: ''})

      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong',
          subdetail: err.response.data,
        })  
      }
    },    
  },
  getters: {
    profanityList: (state) => {
      return state.profanityList.map( item => {
        return { text: item.Word, value: item.ID, editing: item.editing}
      })
    },
    queueList: (state) => {
      return state.queueList.map( item => { 
        return { text: `${item.QueueName} (${item.RecordCount})`, value: '', queueName: item.QueueName}
      })
    }
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    setCampaign(state, data) {
      Object.keys(state).forEach(k => state[k] = data[k] || state[k])
    },
    updatedProfanityList: function(state, data){
      state.profanityList = state.profanityList.map( item => {
        if (item.ID == data ) item.editing = !item.editing
        return item
      })
    }
  },
}